import React, { ReactNode } from 'react'
import { Box, Card, Icon, IconName } from '@node-space/ui-components'
import { LoadingIndicator } from 'components/LoadingIndicator'

export interface EarnAssetStatCardProps {
  icon: IconName
  label: string
  value: string
  highlight?: ReactNode
  testId?: string
  isLoading?: boolean
}

export const EarnAssetStatCard = ({
  icon,
  label,
  value,
  highlight,
  testId,
  isLoading,
}: EarnAssetStatCardProps) => (
  <Card variant="static" full borderRadius={12} testId={testId} className="flex-1 min-w-0">
    <Box flex gap={16}>
      <Box className="text-foreground-action-secondary">
        <Icon name={icon} size="large" />
      </Box>
      <Box width="full" flex gap={8} className="flex-wrap justify-between items-start">
        <Box flexCol gap={4}>
          <p className="text-label text-foreground-subdued">{label}</p>
        </Box>
        {highlight}
      </Box>
    </Box>
    <Box className="pl-[43px]">
      {isLoading ? (
        <LoadingIndicator testId={`${testId}-skeleton`} />
      ) : (
        <h1 className="text-h1 text-foreground-prominent truncate">{value}</h1>
      )}
    </Box>
  </Card>
)
